import styled from '@emotion/styled';

import Box from 'app/components/v2/components/Box';

// Local Typings
interface StyledDivProps {
  isVisible: boolean;
}

// Local Variables
const transitionSpeed = 500;
export const StyledDiv = styled.div<StyledDivProps>(props => ({
  transform: `translateY(${props.isVisible ? '0' : '-100%'})`,
  transition: `${transitionSpeed}ms`,
}));
export const StyledContainer = styled(Box)<{ navHeight: number }>(props => ({
  height: `calc(100% - ${props.navHeight}px)`,
  marginTop: props.navHeight,
  overflowY: 'auto',
}));
